export const USER_MODULE = 'user'

// Action
export const REQUEST_RESET_PASSWORD = 'requestResetPassword'
export const CONFIRM_EMAIL = 'confirmEmail'
export const RESET_REQUEST_RESET_PASSWORD_ERROR = 'setRequestResetPasswordError'
export const RESET_PASSWORD = 'resetPasswordPost'
export const RESET_PASSWORD_LANDING = 'resetPasswordLandingPost'

//Mutation
export const SET_REQUEST_RESET_PASSWORD_ERROR = 'setRequestResetPasswordError'

//Getters
export const REQUEST_RESET_PASSWORD_ERROR = 'getRequestResetPasswordError'
